import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { navigate } from '@reach/router'
import moment from 'moment'
import View from './View'
import { getSlots } from '../../services/booking'
import { colors } from '../Colors'
import { device } from '../Breakpoints'
import VejaTambem from '../VejaTambem'

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
  @media ${device.mobileL} {
    p {
      padding: 2em;
    }
  }
  h2 {
    font-size: 30px !important;
    text-transform: capitalize;
    color: #fa7272;
    background: none;
    text-align: center;
    span {
      font-size: 16px;
      display: block;
      font-weight: normal;
    }
  }
  .pageHeader {
    margin: auto;
    width: 100%;
    display: block;
  }
  section.center {
    margin-top: 2em;
  }
  .buttons {
    width: 500px;
    margin: auto;
    text-align: center;
    button {
      margin: 20px;
    }
    @media ${device.mobileL} {
      width: 420px;
    }
  }
  ul {
    margin: 0;
    padding: 0;
    li {
      list-style: none;
      margin: 0 0 10px 0;
      button {
        border-radius: 50px;
        width: 250px;
        position: relative;
        background: #b5dcce;
        border: none;
        padding: 0.5em;
        margin: auto;
        display: block;
        font-family: 'Santral', Arial, Helvetica, sans-serif;
        font-size: 13px;
        cursor: pointer;
        :hover {
          background: ${colors.verde};
          color: #ffffff;
          span.text {
            color: #ffffff;
          }
        }
        span.time {
          position: absolute;
          left: 10px;
          color: #ffffff;
        }
        span.text {
          color: #539e9f;
          text-transform: uppercase;
        }
      }
      button.active {
        background: ${colors.laranjaGradienteReverso};
        color: #ffffff;
        span.text {
          color: #ffffff;
        }
      }
    }
  }
`

function Horarios() {
  const [data, setData] = useState([])
  const [active, setActive] = useState('')
  const { convenio, day } = window.history.state
  const state = {
    convenio,
    day,
    time: active,
  }

  function timeSelector(time) {
    setActive(time)
  }

  function nextPage() {
    if (state.time) {
      navigate('/agendamento-de-visitas/detalhes', {
        state,
      })
    } else {
      alert('Por favor, selecione um horário.')
    }
  }
  useEffect(() => {
    async function fetchData() {
      const result = await getSlots(day)

      setData(result)
    }
    fetchData()
  }, [])

  return (
    <Container>
      <View>
        <p>Selecione um horário para sua visita:</p>
        <h2>
          {moment(day).format('DD [de] MMMM')}
          <span>{moment(day).format('dddd')}</span>
        </h2>
        <ul>
          {data.map(item => (
            <li key={item}>
              <button
                type="button"
                className={active === item ? 'active' : 'inactive'}
                onClick={() => timeSelector(item)}
              >
                <span className="time">{`${moment(item).format('HH')}h`}</span>
                <span className="text">Agendar</span>
              </button>
            </li>
          ))}
        </ul>
        <div className="buttons">
          <button
            type="button"
            onClick={() => navigate('/agendamento-de-visitas/calendario')}
            className="button prev"
          >
            voltar
          </button>
          <button
            type="button"
            onClick={e => nextPage(e)}
            className="button next"
          >
            Próximo
          </button>
        </div>
      </View>
      <VejaTambem />
    </Container>
  )
}

export default Horarios
